import moment from 'moment'

import { JSX, use, useMemo, Suspense } from 'react'
import { useNavigate } from 'react-router'

import { For, Tabs, Icon } from '@chakra-ui/react'

import { RxDotsVertical } from 'react-icons/rx'


import http, { HttpBody } from '@/lib/request'

import * as locally from '@/lib/locally.js'

import * as company_storage from '@/storage/company.js'


import { Router } from '@/views/supervisor'

// eslint-disable-next-line @typescript-eslint/naming-convention
import * as Loading from '@/components/ui/loading.tsx'
// eslint-disable-next-line @typescript-eslint/naming-convention
import * as Empty from '@/components/ui/empty.tsx'
// eslint-disable-next-line @typescript-eslint/naming-convention
import * as Carte from '@/components/ui/carte.tsx'




type THydratedDocumentType = HttpBody<company_storage.TContractHydratedDocumentType>




// eslint-disable-next-line @typescript-eslint/naming-convention
export function Item (
	props: {
		data: THydratedDocumentType

		children?(data: THydratedDocumentType): JSX.Element

	},

)
:	JSX.Element
{
	let navigate = useNavigate()

	let { archive, user } = props.data

	let on_active = (): void =>
	{
		// eslint-disable-next-line @typescript-eslint/no-floating-promises
		navigate(`./${Router.archive}/${archive._id}`)

	}

	return (
		<Carte.Root>
			<Carte.Posy
				size="xl"
				name={archive.name}
				avatar={archive.idcard}
				text={user.phone!}

			/>

			<Carte.Divider />

			{props.children?.(props.data)}


			<Icon ml="auto" color="blue.solid" cursor="pointer" onClick={on_active}>
				<RxDotsVertical />

			</Icon>

		</Carte.Root>

	)

}

// eslint-disable-next-line @typescript-eslint/naming-convention
export function Lister
(
	props: {
		data: Promise<THydratedDocumentType[]>

		children?(data: THydratedDocumentType): JSX.Element

	},

)
:	JSX.Element
{
	let data = use(props.data)

	if (data.length === 0)
	{
		return <Empty.Miss title="暂无数据" description="暂无数据" />

	}

	return (
		<For each={data}>
			{
				// eslint-disable-next-line @typescript-eslint/unbound-method
				v => <Item key={v._id} data={v} children={props.children} />

			}

		</For>

	)

}


// eslint-disable-next-line @typescript-eslint/naming-convention
export function Content
(
	props:{
		value: string
		data : Promise<THydratedDocumentType[]>

		children?(data: THydratedDocumentType): JSX.Element

	},

)
:	JSX.Element
{
	return (
		<Tabs.Content
			minH="0"
			flex="auto"
			overflowY="auto"
			scrollbarWidth="thin"
			scrollBehavior="smooth"
			scrollbarGutter="stable"
			value={props.value}
		>
			<Suspense fallback={<Loading.Default h="24" />}>
				<Lister
					data={props.data}
					// eslint-disable-next-line @typescript-eslint/unbound-method
					children={props.children}

				/>

			</Suspense>

		</Tabs.Content>

	)

}

// eslint-disable-next-line @typescript-eslint/naming-convention
export function Recently
(
	props: {
		data: THydratedDocumentType

	},

)
:	JSX.Element
{
	let { created, archive } = props.data


	return (
		<>
			<Carte.Feild label="性别" w="24">
				<Carte.B>{archive?.sex ?? '未知'}</Carte.B>

			</Carte.Feild>

			<Carte.Feild label="年龄" w="24">
				<Carte.B>{archive?.age ?? '未知'}</Carte.B>

			</Carte.Feild>

			<Carte.Feild label="入职时间" align="start">
				<Carte.B>{locally.date(created, { format: 'YYYY.MM.DD' })}</Carte.B>

			</Carte.Feild>

		</>

	)

}

// eslint-disable-next-line @typescript-eslint/naming-convention
export function Overdued
(
	props: {
		data: THydratedDocumentType

	},

)
:	JSX.Element
{
	let { office, insurance, finish, lave } = props.data


	return (
		<>
			<Carte.Feild label="岗位" w="32">
				<Carte.B fontSize="lg">{office || '无'}</Carte.B>

			</Carte.Feild>

			<Carte.Feild label="险种" w="32">
				<Carte.B>{insurance || '无'}</Carte.B>

			</Carte.Feild>

			<Carte.Feild label="协议至" align="start">
				<Carte.B>{locally.date(finish!, { format: 'YYYY.MM.DD' })}</Carte.B>
				<Carte.Span fontSize="sm">{`(${lave}天)`}</Carte.Span>

			</Carte.Feild>

		</>

	)

}

export default function
(
	props: {
		_id: string

	},

)
:	JSX.Element
{
	let [recently, overdued] = useMemo(
		() => [
			company_storage.retrieve_contracts(
				props._id,

				{
					skip : 0,
					limit: 99,
					sort : ['-created'],

					resigned: null,
					// eslint-disable-next-line @stylistic/newline-per-chained-call
					created	: [moment(http.now).subtract(1, 'month').toDate()],

				},

			),

			company_storage.retrieve_contracts(
				props._id,

				{
					skip : 0,
					limit: 99,
					sort : ['-created'],

					resigned: null,
					// eslint-disable-next-line no-sparse-arrays, @stylistic/newline-per-chained-call
					finish  : [, moment(http.now).add(1, 'month').toDate()],

				},


			),

		],

		[props._id],

	)

	return (
		<Tabs.Root
			w="full"
			h="full"
			colorPalette="red"
			orientation="vertical"
			defaultValue="recently"
		>
			<Tabs.List>
				<Tabs.Trigger value="recently">最新入职</Tabs.Trigger>
				<Tabs.Trigger value="overdued">协议到期</Tabs.Trigger>

			</Tabs.List>

			<Content key="recently" value="recently" data={recently}>
				{ v => <Recently data={v} /> }

			</Content>

			<Content key="overdued" value="overdued" data={overdued}>
				{ v => <Overdued data={v} /> }

			</Content>

		</Tabs.Root>

	)

}
